export const mfBankList = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "exp": 1701734415598,
        "info": 4
    },
    "data": {
        "type": "mfBankDetailsResponseDao",
        "details": {
            "bnkAcs": [
                {
                    "bankTyp": "DIRECT",
                    "bankid": 2,
                    "bnkAccNo": "055801627626",
                    "bnkCode": "ICI",
                    "bnkName": "ICICI BANK LTD",
                    "fndTrsAvl": false,
                    "ifsc": "ICIC0000570",
                    "latest": false,
                    "lstPayMode": 0,
                    "upiAvl": true,
                    "upiintent": true,
                    "upiqr": true
                },
                {
                    "bankTyp": "DIRECT",
                    "bankid": 15,
                    "bnkAccNo": "38736516223",
                    "bnkCode": "SBI",
                    "bnkName": "STATE BANK OF INDIA",
                    "brcName": "NA NA NA NA",
                    "fndTrsAvl": false,
                    "ifsc": "SBIN0000772",
                    "latest": true,
                    "lstPayMode": 0,
                    "upiAvl": true,
                    "upiintent": true,
                    "upiqr": true
                }
            ],
            "ldgrs": [
                {
                    "ldgrId": "",
                    "ldgrNm": ""
                }
            ],
            "payinMntFlg": false,
            "payoutMntFlg": false,
            "pndPayout": false,
            "upiHdlInfo": [
                {
                    "handlelimit": "100000",
                    "handlename": "@upi"
                },
                {
                    "handlelimit": "100000",
                    "handlename": "@genericupi"
                }
            ],
            "upis": [
                {
                    "bankaccountnumber": "055801627626",
                    "bankid": 2,
                    "isprimary": true,
                    "upi": "8123083885@paytm",
                    "upid": "250242",
                    "valid": true
                },
                {
                    "bankaccountnumber": "055801627626",
                    "bankid": 2,
                    "isprimary": false,
                    "upi": "8123083885@ybl",
                    "upid": "256242",
                    "valid": true
                },
                {
                    "bankaccountnumber": "055801627626",
                    "bankid": 2,
                    "isprimary": false,
                    "upi": "kumarabsabhishek@okicici",
                    "upid": "253105",
                    "valid": true
                },
                {
                    "bankaccountnumber": "055801627626",
                    "bankid": 2,
                    "isprimary": false,
                    "upi": "abhi007kumar@icici",
                    "upid": "239552",
                    "valid": true
                }
            ]
        },
        "liqCutoff": "12:50 PM",
        "nonLiqCutoff": "2:20 PM"
    },
    "msgID": "5b473bff-1ea6-4516-acba-fe10c4b205b6",
    "srvTm": 1701762102326
};
export const PlaceOrderSuccess = {
    "appID": "051387c9d35aadcf36371636a2a371a7",
    "data": {
        "ordNo": "930769",
        "msg": "Fresh XSIP order request for order id - 930769 has been successfully placed and sent to MF BSE."
    },
    "msgID": "0d346f12-e0fc-4fa3-b712-1a9a29d938cb",
    "srvTm": "1701762101985",
    "error": ""
};
export const UpiPayment = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "exp": 1701734415598,
        "info": 4
    },
    "data": {
        "type": "paymentGatewayResponseDao",
        "responsestring": "BSE StAR MF has requested payment from your UPI account. To authorise debit please login to your UPI account.",
        "exOrdNo": "930639876"
    },
    "msgID": "530495b7-9e46-499b-a0cf-12f3dea257d2",
    "srvTm": 1701762304495
};
export const IbPayment = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "exp": 1699574414671,
        "info": 4
    },
    "data": {
        "type": "paymentGatewayResponseDao",
        "responsestring": "\r\n\r\n\r\n\r\n<html>\r\n<head><title>Redirecting to Bank</title>\r\n<style>\r\n\r\n.bodytxt4 {\r\n\r\n\tfont-family: Verdana, Arial, Helvetica, sans-serif;\r\n\tfont-size: 12px;\r\n\tfont-weight: bold;\r\n\tcolor: #666666;\r\n}\r\n.bodytxt {\r\n\tfont-family: Verdana, Arial, Helvetica, sans-serif;\r\n\tfont-size: 13px;\r\n\tfont-weight: normal;\r\n\tcolor: #000000;\r\n\r\n}\r\n.bullet1 {\r\n\r\n\tlist-style-type:\tsquare;\r\n\tlist-style-position: inside;\r\n\tlist-style-image: none;\r\n\tfont-family: Verdana, Arial, Helvetica, sans-serif;\r\n\tfont-size: 10px;\r\n\tfont-weight: bold;\r\n\tcolor: #FF9900;\r\n}\r\n.bodytxt2 {\r\n\tfont-family: Verdana, Arial, Helvetica, sans-serif;\r\n\tfont-size: 8pt;\r\n\tfont-weight: normal;\r\n\tcolor: #333333;\r\n\r\n}\r\nA.sac2 {\r\n\tCOLOR: #000000;\r\n\tfont-family: Verdana, Arial, Helvetica, sans-serif;\r\n\tfont-size: 10px;\r\n\tfont-weight: bold;\r\n\ttext-decoration: none;\r\n}\r\nA.sac2:visited {\r\n\tCOLOR: #314D5A; TEXT-DECORATION: none\r\n}\r\nA.sac2:hover {\r\n\tCOLOR: #FF9900; TEXT-DECORATION: underline\r\n}\r\n</style>\r\n\r\n</head>\r\n<script language=JavaScript>\r\n\r\n\r\nvar message=\"Function Disabled!\";\r\n\r\n\r\nfunction clickIE4(){\r\nif (event.button==2){\r\nreturn false;\r\n}\r\n}\r\n\r\nfunction clickNS4(e){\r\nif (document.layers||document.getElementById&&!document.all){\r\nif (e.which==2||e.which==3){\r\nreturn false;\r\n}\r\n}\r\n}\r\n\r\nif (document.layers){\r\ndocument.captureEvents(Event.MOUSEDOWN);\r\ndocument.onmousedown=clickNS4;\r\n}\r\nelse if (document.all&&!document.getElementById){\r\ndocument.onmousedown=clickIE4;\r\n}\r\n\r\ndocument.oncontextmenu=new Function(\"return false\")\r\n\r\n</script>\r\n<table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\">\r\n  <tr>\r\n    <td align=\"left\" valign=\"top\">\r\n<table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\">\r\n        <tr> \r\n          <td align=\"center\" valign=\"middle\"><table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\">\r\n             \r\n              <tr>\r\n                <td  align=\"center\"></td>\r\n              </tr>\r\n              <tr>\r\n                <td height=\"85\" align=\"center\"><br>\r\n                  <table width=\"80%\" border=\"0\" cellpadding=\"0\" cellspacing=\"1\" bgcolor=\"#CCCCCC\">\r\n                    <tr>\r\n                      <td bgcolor=\"#CCCCCC\"><table width=\"100%\" border=\"0\" cellpadding=\"6\" cellspacing=\"0\" bgcolor=\"#FFFFFF\">\r\n                          <tr> \r\n                            <td colspan=\"2\" align=\"left\" valign=\"bottom\"><span class=\"bodytxt4\">Your payment request is being processed...</span></td>\r\n                          </tr>\r\n                          <tr valign=\"top\"> \r\n                            <td colspan=\"2\" align=\"left\"><table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\">\r\n                                <tr> \r\n                                  <td width=\"87%\" bgcolor=\"#cccccc\" height=\"1\" align=\"center\"></td>\r\n                                </tr>\r\n                              </table></td>\r\n                          </tr>\r\n                          <tr> \r\n                            <td width=\"60%\" align=\"left\" valign=\"bottom\"><table width=\"95%\" border=\"0\" cellpadding=\"1\" cellspacing=\"0\" bgcolor=\"#FFFFFF\">\r\n                                <tr> \r\n                                  <td align=\"right\" valign=\"top\"></td>\r\n                                  <td class=\"bodytxt\">&nbsp;</td>\r\n                                </tr>\r\n                                <tr> \r\n                                  <td height=\"19\"  align=\"right\" valign=\"top\"><li class=\"bullet1\"></li></td>\r\n                                  <td class=\"bodytxt2\">This is a secure payment \r\n                                    gateway using 128 bit SSL encryption.</td>\r\n                                </tr>\r\n                                <tr> \r\n                                  <td align=\"right\" valign=\"top\"> <li class=\"bullet1\"></li></td>\r\n                                  <td class=\"bodytxt2\" >When you submit the transaction, \r\n                                    the server will take about 1 to 5 seconds \r\n                                    to process, but it may take longer at certain \r\n                                    times. </td>\r\n                                </tr>\r\n                                <tr> \r\n                                  <td align=\"right\" valign=\"top\"><li class=\"bullet1\"></li></td>\r\n                                  <td class=\"bodytxt2\" >Please do not press \"Submit\" \r\n                                    button once again or the \"Back\" or \"Refresh\" \r\n                                    buttons. </td>\r\n                                </tr>\r\n                              </table></td>\r\n                            <td align=\"right\" valign=\"bottom\"><table width=\"80%\" border=\"0\" cellpadding=\"1\" cellspacing=\"0\" bgcolor=\"#FFFFFF\">\r\n                                <tr bgcolor=\"#FFFCF8\"> \r\n                                  <td align=\"right\" bgcolor=\"#FFFFFF\"></td>\r\n                                </tr>\r\n                                <tr bgcolor=\"#FFFCF8\"> \r\n                                  <td align=\"right\" valign=\"middle\" bgcolor=\"#FFFFFF\" class=\"bodytxt2\">&nbsp;</td>\r\n                                </tr>\r\n                                <tr bgcolor=\"#FFFCF8\"> \r\n                                  <td align=\"right\" bgcolor=\"#FFFFFF\" class=\"bodytxt2\" >&nbsp;</td>\r\n                                </tr>\r\n                              </table></td>\r\n                          </tr>\r\n                        </table></td>\r\n                    </tr>\r\n                  </table>\r\n                  \r\n                </td>\r\n              </tr>\r\n            </table>\r\n           \r\n          \r\n         \r\n             </td>\r\n        </tr>  \r\n\r\n\r\n      </table></td>\r\n  </tr>\r\n  \r\n</table>\r\n\r\n\r\n\r\n<body>\r\n<form name=\"Bankfrm\" method=\"post\" action='https://shopping.icicibank.com/corp/BANKAWAY?IWQRYTASKOBJNAME=bay_mc_login&BAY_BANKID=ICI'>\r\n \r\n\t\t\t  \r\n              <input type = \"hidden\" name = \"MD\" value=\"P\">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = \"hidden\" name = \"PID\" value=\"000000001086\">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = \"hidden\" name = \"ES\" value=\"vS+WplcnmtRvVIneMuUGNlHwLIInTohTlcrhu/iU0ZOiEg1LbBRXlkYwp9vcN+16jFnWhPSFt8onCI5Rx30OhYdO9Zf6jcrbF4IfETqOVOXDMz9//eNdXILxcdsbg9N2LHPkKRUX+tKYEzxQiJt2x+P1dOS2G6xePFUYtTe9cnH/aNlIc3gr9WTb/+31zH4SlWx9VUKxhCuKxH0ryiUOpSTTvXvnQnv7ABeFcOvFbeCcGpoaPFcwJhIQPWrWmdDC\">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = \"hidden\" name = \"SPID\" value=\"NA\">\r\n\t\t\t\r\n              \r\n\t</form>\r\n</body>\r\n<script>\r\ndocument.Bankfrm.submit();\r\n</script>\r\n</html>\r\n",
        "exOrdNo": "902161091"
    },
    "msgID": "a63e7397-df3a-46e5-8c56-c60a057e555d",
    "srvTm": 1699608204188
};
export const statusPending = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "exp": 1701734415598,
        "info": 4
    },
    "data": {
        "type": "paymentStatusResponseDao",
        "exOrdNo": "930639876",
        "status": "CONTINUE"
    },
    "msgID": "2cb8385c-7809-49c8-b575-0a3090a6c5ec",
    "srvTm": 1701762509845
};
export const statusRetry = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "exp": 1701734415598,
        "info": 4
    },
    "data": {
        "type": "paymentStatusResponseDao",
        "exOrdNo": "930639876",
        "status": "RETRY"
    },
    "msgID": "4897f25f-e73a-4b3f-9d58-0d9002706d16",
    "srvTm": 1701762971987
};
